/**
 * Application version
 * This is automatically injected during build process
 */
export const APP_VERSION = process.env.APP_VERSION || '0.0.0';

/**
 * Build date
 * This is automatically injected during build process
 */
export const BUILD_DATE = process.env.BUILD_DATE || new Date().toISOString();

/**
 * Get formatted version string
 */
export function getAppVersion(): string {
    return APP_VERSION;
}

/**
 * Get version parts
 */
export function getVersionParts(): { major: number; minor: number; patch: number } {
    const [major, minor, patch] = APP_VERSION.split('.').map(Number);
    return { major, minor, patch };
}

/**
 * Get build date as ISO string
 */
export function getBuildDate(): string {
    return BUILD_DATE;
}

/**
 * Get build date as Date object
 */
export function getBuildDateObject(): Date {
    return new Date(BUILD_DATE);
}

/**
 * Get formatted build date
 */
export function getFormattedBuildDate(locale = 'cs-CZ'): string {
    const date = new Date(BUILD_DATE);
    return date.toLocaleString(locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    });
}

